import { Grid, Snackbar } from '@material-ui/core';
import { WithStyles, createStyles } from '@material-ui/core/styles';
import { Alert } from '@material-ui/lab';
import * as H from 'history';
import TermKeh from 'pages/InsurancePages/KppTerm/TermKeh';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { WithTranslation } from 'react-i18next';
import MediaQuery from 'react-responsive';
import { Prompt } from 'react-router';
import { RouteComponentProps, useParams } from 'react-router-dom';
import {
	STEP_KPP_VEHICLE,
	STEP_KPP_TERM,
	STEP_CLIENT_DATA_1,
	STEP_CLIENT_DATA_2,
	STEP_PAYMENT,
	STEP_REVIEW,
	STEP_KPP_REVIEW,
	STEP_AGREEMENT,
	// STEP_SIGNATURE,
	STEP_TERM_KEH,
	FORM_REVIEW_KEH,
	STEP_AGREEMENT_KEH,
	STEP_EP_VEHICLE,
	STEP_EP_REVIEW,
} from 'redux/reducers/contractWizard/constants';
import DocumentModal from '../../components/DocumentModal/DocumentModal';
import { GenericModal } from '../../components/GenericModal/GenericModal';
import { Header } from '../../components/Header/Header';
import Loading from '../../components/Loading/Loading';
import { QuickMenu } from '../../components/QuickMenu/QuickMenu';
import { Stepper } from '../../components/Stepper/Stepper';
import { ROUTE_HOME, ROUTE_LOGIN, ROUTE_THANKYOU } from '../../lib/constants';

import { useUniversalTracking } from '../../lib/tracking/universalTracking';
import { ApiError } from '../../types/api';
import { ContractState, SalesType} from '../../types/redux';
import {isInEnum, toEnum} from '../../utils/enum';
import { addLineBreaks } from '../../utils/formatString';
import Agreement from '../InsurancePages/Agreement/Agreement';
import AgreementKeh from '../InsurancePages/Agreement/AgreementKeh';
import Contact from '../InsurancePages/Contact';
import ReviewKeh from '../InsurancePages/KppReview/ReviewKeh';
import { KppVehicle } from '../InsurancePages/KppVehicle/KppVehicle';
import { KppReview } from '../InsurancePages/KppReview/KppReview';
import { KppTerm } from '../InsurancePages/KppTerm/TermKpp';

import Payment from '../InsurancePages/Payment';
import Review from '../InsurancePages/Review';
import UserData from '../InsurancePages/UserData';
import {EpVehicle} from "../InsurancePages/EpVehicle/EpVehicle";
import {EpReview} from "../InsurancePages/EpReview/EpReview";

const stepperBreakpoint = 670;

export const styles = () =>
	createStyles({
		input: {
			backgroundColor: 'white',
			color: '#4B4B4A',
			fontSize: 14,
		},

		'.contract_wizard_back_stepper_container': {
			marginTop: '15px',
		},
		'.contract_wizard_mobile_stepper_wrapper': {
			display: 'flex',
			marginTop: '15px',
			justifyContent: 'space-between',
			alignItems: 'center',
		},
		'.contract_wizard_mobile_stepper_current_step': {
			display: 'flex',
			padding: '32px 0 12px 0',
		},
		'.contract_wizard_mobile_stepper_current_step_number': {
			height: '28px',
			width: '28px',
			backgroundColor: '#0463c2',
			borderRadius: '50%',
			marginRight: '15px',
			textAlign: 'center',
			lineHeight: '27px',
			color: 'white',
		},
		'.contract_wizard_mobile_stepper_current_step_name': {
			lineHeight: '27px',
			color: 'rgba(0, 0, 0, 0.9)',
			fontWeight: 500,
			fontSize: '17.2px',
			textAlign: 'center',
		},
	});

interface StateProps {
	steps: string[];
	forms: string[];
	currentStep: number;
	currentForm: number;
	error: ApiError | undefined;
	contract: ContractState;
	isLoading: boolean;
}

interface DispatchProps {
	newWizard(salesType: SalesType): void;
	continueContract(data: any): void;
	resetContractToStep(step: number): void;
	goPreviousForm(): void;
}
interface Props
	extends WithTranslation,
		WithStyles<typeof styles>,
		RouteComponentProps,
		StateProps,
		DispatchProps {}

const getPageComponentByStep = (
	step: string,
	handleNext: (data: any, goToEnd?: boolean) => void,
	salesType: SalesType
) => {
	//console.log("GET PAGE TO RENDER", step, handleNext, salesType);
	switch (step) {
		case STEP_EP_VEHICLE:
			return <EpVehicle onSubmit={handleNext} />;
		case STEP_KPP_VEHICLE:
			return <KppVehicle onSubmit={handleNext} />;
		case STEP_KPP_TERM:
			return <KppTerm onSubmit={handleNext} />;
		case STEP_TERM_KEH:
			return <TermKeh onSubmit={handleNext} />;
		case STEP_CLIENT_DATA_1:
			return <Contact onSubmit={handleNext} />;
		case STEP_CLIENT_DATA_2:
			return <UserData onSubmit={handleNext} />;
		case STEP_PAYMENT:
			return <Payment onSubmit={handleNext} />;
		case STEP_REVIEW:
			return <Review onSubmit={handleNext} />;
		case STEP_EP_REVIEW:
			return <EpReview onSubmit={handleNext} />;
		case STEP_KPP_REVIEW:
			return <KppReview onSubmit={handleNext} />;
		case FORM_REVIEW_KEH:
			return <ReviewKeh onSubmit={handleNext} />;
		case STEP_AGREEMENT:
			return <Agreement onSubmit={handleNext} />;
		case STEP_AGREEMENT_KEH:
			return <AgreementKeh onSubmit={handleNext} />;
		// case STEP_SIGNATURE:
		// 	return <Signature onSubmit={handleNext} contractType={contractType} />;

		default:
			return null;
	}
};

const ContractWizard: FunctionComponent<Props> = (props) => {
	const { trackEvent, trackPageView } = useUniversalTracking();
	const [stepToGoBack, setStepToGoBack] = useState(-1);
	const [showGoHomeModal, setShowGoHomeModal] = useState(false);
	const [showStepperModal, setShowStepperModal] = useState(false);
	const [confirmedLeavePage, setConfirmedLeavePage] = useState(false);
	const [leaveToHome, setLeaveToHome] = useState(false);
	const { history, goPreviousForm, currentStep, newWizard, currentForm } = props;
	const { salesType } = useParams<{ salesType: SalesType }>();
	const isValidSalesType = isInEnum(SalesType, salesType);
	const salesTypeEnum = toEnum(SalesType, salesType)  as SalesType || SalesType.UNDEFINED;
	if (!isValidSalesType) {
		console.error('Error: unknown sales type', salesType);
	}

	useEffect(() => {
		newWizard(salesTypeEnum);
		// eslint-disable-next-line
	}, [newWizard, salesType]);

	useEffect(() => {
		if (confirmedLeavePage) {
			if (leaveToHome || currentStep === 0) {
				newWizard(salesTypeEnum);
				history.push(`/${ROUTE_HOME}`);
			} else {
				goPreviousForm();
				setConfirmedLeavePage(false);
			}
		}
	}, [
		confirmedLeavePage,
		history,
		goPreviousForm,
		currentStep,
		leaveToHome,
		newWizard,
		salesTypeEnum,
	]);

	useEffect(
		() => {
			trackPageView(`${props.location.pathname}/${currentForm + 1}`);
		},
		// eslint-disable-next-line
		[props.location.pathname, currentForm]
	);

	const getContractErrors = () => {
		if (props.error) {
			return (
				<Snackbar
					open={Boolean(props.error)}
					anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
				>
					<Alert severity="error">{props.error.error}</Alert>
				</Snackbar>
			);
		}

		return null;
	};

	function totalForms(): number {
		return props.forms.length;
	}

	function isLastForm(): boolean {
		return props.currentForm === totalForms() - 1;
	}

	const handleNext = (data: any, goToEnd?: boolean) => {
		if (!props.isLoading) {
			if (isLastForm() || goToEnd) {
				props.history.push(`/${ROUTE_THANKYOU}/${salesTypeEnum}`);
			} else {
				props.continueContract(data);
			}
		}
	};

	const handleStep = (step: number) => () => {
		if (props.currentStep > step) {
			setStepToGoBack(step);
		}
	};

	const showConfirmGoBackModal = () => stepToGoBack !== -1;

	const confirmToGoBack = () => {
		trackEvent({
			category: 'goBack-submit',
			action: 'click-event',
			label: 'goBack',
		});
		props.resetContractToStep(stepToGoBack);
		setShowStepperModal(false);
		setStepToGoBack(-1);
	};

	const cancelConfirmGoBackModal = () => {
		setStepToGoBack(-1);
	};

	const confirmGoHomeModal = () => {
		if (showGoHomeModal) {
			return (
				<GenericModal
					showModal={true}
					okButton={{
						handleFn: () => {
							setConfirmedLeavePage(true);
							setShowGoHomeModal(false);
						},
						text: props.t('home_button.yes'),
					}}
					cancelButton={{
						handleFn: () => setShowGoHomeModal(false),
					}}
				>
					<div>{addLineBreaks(props.t('home_button.message'))}</div>
				</GenericModal>
			);
		}

		return null;
	};

	const shouldShowPromptMessage = (location: H.Location) =>
		!confirmedLeavePage &&
		!location.pathname.startsWith(`/${ROUTE_THANKYOU}`) &&
		!location.pathname.startsWith(`/${ROUTE_LOGIN}`);

	const wantToGoHome = (location: H.Location) =>
		location.pathname.startsWith(`/${ROUTE_HOME}`);

	const mobileStepperButton = () => (
		<MediaQuery maxDeviceWidth={stepperBreakpoint}>
			<div className={props.classes['.contract_wizard_mobile_stepper_wrapper']}>
				<div
					className={
						props.classes['.contract_wizard_mobile_stepper_current_step']
					}
				>
					<div
						className={
							props.classes[
								'.contract_wizard_mobile_stepper_current_step_number'
							]
						}
						onClick={() => setShowStepperModal(!showStepperModal)}
					>
						{currentStep + 1}
					</div>
					<div
						className={
							props.classes['.contract_wizard_mobile_stepper_current_step_name']
						}
					>
						{props.steps[props.currentStep]}
					</div>
				</div>
			</div>
		</MediaQuery>
	);

	const mobileStepperModal = () =>
		showStepperModal && (
			<div className="contract_wizard_mobile_stepper_modal">
				<DocumentModal
					showModal={showStepperModal}
					handleCloseFn={() => setShowStepperModal(false)}
				>
					{renderStepper(true)}
				</DocumentModal>
			</div>
		);

	const promptMessage = (location: H.Location) => {
		if (shouldShowPromptMessage(location)) {
			setShowGoHomeModal(true);
			if (wantToGoHome(location)) {
				setLeaveToHome(true);
			} else {
				setLeaveToHome(false);
			}

			return false;
		}

		return true;
	};

	const renderStepper = (isVertical: boolean) => (
		<Stepper
			steps={props.steps}
			activeStep={props.currentStep}
			handleStep={handleStep}
			isVertical={isVertical}
		/>
	);
	// console.log("GET PAGE TO RENDER 1", props.forms[props.currentForm], handleNext, contractType)
	return (
		<>
			<Prompt message={promptMessage} />
			<Header />
			{props.isLoading && <Loading showSpinner={true} />}

			<Grid container justifyContent="center">
				<Grid item xs={10}>
					<MediaQuery minDeviceWidth={stepperBreakpoint + 1}>
						<div
							className={
								props.classes['.contract_wizard_back_stepper_container']
							}
						>
							{renderStepper(false)}
						</div>
					</MediaQuery>
					{mobileStepperButton()}
					{getPageComponentByStep(
						props.forms[props.currentForm],
						handleNext,
						salesTypeEnum
					)}
					{getContractErrors()}
				</Grid>
			</Grid>

			<GenericModal
				showModal={showConfirmGoBackModal()}
				okButton={{
					handleFn: confirmToGoBack,
					text: props.t('common.yes'),
				}}
				cancelButton={{
					handleFn: cancelConfirmGoBackModal,
				}}
			>
				<div>{props.t('contractWizard.goBackConfirmation')}</div>
			</GenericModal>
			<QuickMenu />
			{confirmGoHomeModal()}
			{mobileStepperModal()}
		</>
	);
};

export default ContractWizard;
